import {ProductInDetailMapType, ProductInDetailType} from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import React from "react";
import {UseFormRegister, UseFormWatch} from "react-hook-form";
import {useUser} from "../../../../../util/userContext/UserContext";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    productDetail: ProductInDetailMapType
    register: UseFormRegister<ProductInDetailType>
    watch: UseFormWatch<ProductInDetailType>
    btnSave: () => any
}

export default function Upper({productDetail, register, watch, btnSave}: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser()

    const goToList = () => {
        goToNavigation("product/list", {}, false)
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">제품 상세보기</h3>
            <div className="filter_toolbar">
                {/*<AuthorityChecker authorityNames={['productWriteYn']}>*/}
                <label className="form-label m-0 w-65px me-2">상태 (외부)</label>
                <select className="form-select h-38px w-150px me-40px"
                        value={watch("outFlag")}
                        {...register("outFlag")}
                        disabled={user?.authority.productWriteYn === "N"}>
                    <option value="N">활성</option>
                    <option value="Y">비활성</option>
                </select>
                <AuthorityChecker authorityNames={['productWriteYn']}>
                    <button className="btn btn-primary w-100px h-38px" onClick={btnSave}>저장</button>
                </AuthorityChecker>
                <button className="btn btn-outline-primary w-100px h-38px" onClick={goToList}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                </button>
            </div>
        </div>

        <h5 className="subheading">제품 정보</h5>
        <table className="table table-bordered my_table table_detail m-0">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>품목명</th>
                <td colSpan={3}>{productDetail.productDetailRes.newTxtNmItem}</td>
            </tr>
            <tr>
                <th>생성일자</th>
                <td style={{width: "31.3%"}}>{productDetail.productDetailRes.createdon}</td>
                <th style={{width: "16.66%"}}>생성자</th>
                <td>{productDetail.productDetailRes.nameOfCreator}</td>
            </tr>
            </tbody>
        </table>
    </div>
}